import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import Const from 'constants';

class PlayersGroupExclusionSwitcher extends Component {
    onCheck(isExcluded) {
        const {players, activeMode = Const.FLEX_MODE} = this.props;
        const list = {[activeMode]: {}};
        players.map((player) => (list[activeMode][player.getId()] = isExcluded));
        this.props.dispatch(Action.set('ExcludedPlayers', list));
    }

    isAtLeastOneExcluded() {
        const {players, playersExclusion, activeMode = Const.FLEX_MODE} = this.props;
        for (let player of players) {
            if (playersExclusion.isExcluded(player.getId(), activeMode)) {
                return true;
            }
        }
        return false;
    }

    render() {
        const {className = '', label} = this.props;
        const isExcluded = this.isAtLeastOneExcluded();

        if (label) {
            return (
                <div className="label-block" onClick={() => ::this.onCheck(!isExcluded)}>
                    <button
                        type="button"
                        className={`${className} checkbox-btn${!isExcluded ? ' active' : ''}`}
                        title={isExcluded ? 'Disable exclusion for all players' : 'Enable exclusion for all players'}
                    >
                        {isExcluded ? 'Exclude enabled' : 'Exclude disabled'}
                    </button>
                    <span className="label-block-text">{label}</span>
                </div>
            );
        }

        return (
            <button
                type="button"
                className={`${className} checkbox-btn${!isExcluded ? ' active' : ''}`}
                onClick={() => ::this.onCheck(!isExcluded)}
                title={isExcluded ? 'Disable exclusion for all players' : 'Enable exclusion for all players'}
            >
                {isExcluded ? 'Exclude enabled' : 'Exclude disabled'}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {playersExclusion} = state;
    return {
        playersExclusion,
    };
}

export default connect(mapStatesToProps)(PlayersGroupExclusionSwitcher);
